var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canShowFreeDevices)?_c('div',{staticClass:"ml-auto mr-2"},[(_vm.tab === 'devices')?_c('p',[_vm._v(_vm._s(((_vm.t({s: 'statistics.availableDevices', component: 'Businesses'})) + " " + _vm.freeDevices)))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }